import * as React from "react";

const st: React.CSSProperties = {
    top: 63,
    bottom: 0,
    left: 0,
    right: 0,
    position: "fixed",
    backgroundColor: "rgb(225, 225, 225, .6)",
}
export function Loading(props: any) {
    return <div className="d-flex align-items-center justify-content-center" style={st}>
        <div className="spinner">
            <div className="bounce1" />
            <div className="bounce2" />
            <div className="bounce3" />
        </div>
    </div>
}